import React, { useState, useEffect } from "react";
import { Button, Input, Table , Form, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { IConstructorJsxFilteredBanks } from "../../interfaces/Constructor/IConstructorJsxFilteredBanks";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import {
  BANK_ARCHIVE,
  CHANGE_BANK_FORM_DISABLE,
  CHANGE_BANK_FORM_INITIAL,
  CHANGE_BANK_FORM_TYPE,
  CHANGE_SELECTED_BANK,
  IBank,
} from "../../store/slice/banksSlice/banksSlice";
import {
  SELECT_BANK,
  SELECT_BANK_LIST_ACTIVE,
  SELECT_BANK_LIST_ARCHIVE,
  SELECT_FORM_BANK_TYPE,
} from "../../store/selectors/banksSelector";
import { useArchiveBankMutation } from "../../store/api/banks.api";
import { ITableBank } from "../../interfaces/ITableBank";
import { EditableCell } from "../../components/EditableCell/EditableCell";
import { OPEN_BANK_CHRONOLOGY_MODAL } from "../../store/slice/modalSlice/modalSlice";
import { BankChronologyModal } from "../../components/modals/BankChronologyModal/BankChronologyModal";

import classes from "./style/PageBank.module.css";

// страница списка банков
export function PageBanks() {
  const dispatch = useAppDispatch();
  const bankList = useAppSelector(SELECT_BANK_LIST_ACTIVE);
  const archiveBanks = useAppSelector(SELECT_BANK_LIST_ARCHIVE);
  const selectedBank = useAppSelector(SELECT_BANK);
  // const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [filteredBank, setFilteredBank] = useState<IBank[]>(bankList);
  const [filteredBankArchive, setFilteredBankArchive] =
    useState<IBank[]>(archiveBanks);
  const [bankConstructor, setBankConstructor] =
    useState<keyof IConstructorJsxFilteredBanks>("LIST");
  const [archiveBank, { isError: archiveError }] = useArchiveBankMutation();
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record: IBank) => record.key === editingKey;

  // запись банков в архивные и активные
  useEffect(() => {
    setFilteredBank(bankList);
    setFilteredBankArchive(archiveBanks);
  }, [bankList, archiveBanks]);

  const changeSelectedBank = (bank: IBank) => {
    const { title, excess } = bank;

    dispatch(CHANGE_SELECTED_BANK(bank));
    dispatch(CHANGE_BANK_FORM_DISABLE(true));
    dispatch(CHANGE_BANK_FORM_INITIAL({ title, excess }));
    dispatch(CHANGE_BANK_FORM_TYPE("INFO"));
  };

  const edit = (record: Partial<IBank>) => {
    form.setFieldsValue({ 
      bankName: 0, 
      basicProcent: 0, 
      procentKVFFromRate: 0,
      procentABFromRate: 0,
      excessProcentTatbg: 0,
      excessProcentAgent: 0,
      excessProcentBank: 0,
      dateStartAction: new Date(),
      ...record 
    });

    setEditingKey(record.key!);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async () => {
    setEditingKey('');
  };

  const openBankChronologyModal = () => {
    dispatch(OPEN_BANK_CHRONOLOGY_MODAL());
  };

  const columnsBankTable = [
    {
      title: "Банк",
      dataIndex: "bankName",

    },
    {
      title: "Базовая ставка %",
      dataIndex: "basicProcent",
      editable: true,
    },
    {
      title: "КВ от тарифа  (ТатБГ) %",
      dataIndex: "procentKVFFromRate",
      editable: true,
    },
    {
      title: "АВ от тарифа (Агента) %",
      dataIndex: "procentABFromRate",
      editable: true,
    },
    {
      title: "Превышение (ТатБГ) %",
      dataIndex: "excessProcentTatbg",
      editable: true,
    },
    {
      title: "Превышение (Агент) %",
      dataIndex: "excessProcentAgent",
      editable: true,
    },
    {
      title: "Превышение (Банка) %",
      dataIndex: "excessProcentBank",
      editable: true,
    },
    {
      title: "Дата начала действия",
      dataIndex: "dateStartAction",
      editable: true,
    },
    {
      title: "",
      dataIndex: "hronologia",
      render: (_: any, record: IBank) => {
        return (
          <span  className={classes.pageBankShowByHoverCell}>
            <Typography.Link onClick={() => openBankChronologyModal()}>
              Хронология
            </Typography.Link>
          </span>
        );
      },
    },
    {
      title: "",
      dataIndex: "operation",
      render: (_: any, record: IBank) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link onClick={() => save()}>
              Отмена
            </Typography.Link>
          </span>
        ) : (
          <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
            Редактировать
          </Typography.Link>
        );
      },
    },
  ];

  const dataBankTableSource: ITableBank[] = filteredBank?.map((item: IBank) => {
    const {
      id,
      title,
    } = item;

    return {
      bankName: title,
      key: id,
      basicProcent: 1,
      procentKVFFromRate: 1,
      procentABFromRate: 1,
      excessProcentTatbg: 1,
      excessProcentAgent: 1,
      excessProcentBank: 1,
      dateStartAction: '01.02.2025',
      
    };
  });

  const mergedColumns = columnsBankTable.map((col: any) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        inputType: col.dateStartAction === 'dateStartAction' ? 'date' : 'number',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const editBankInfo = () => {
    dispatch(CHANGE_BANK_FORM_DISABLE(false));
    dispatch(CHANGE_BANK_FORM_TYPE("EDIT"));
  };

  const handleSearch = (value: string) => {
    setFilteredBank(() => {
      if (value) {
        return bankList?.filter((bank: IBank) => {
          return bank.title.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        return bankList;
      }
    });
    setFilteredBankArchive(() => {
      if (value) {
        return archiveBanks?.filter((bank: IBank) => {
          return bank.title.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        return archiveBanks;
      }
    });
    if (filteredBank?.length === 0) {
      setBankConstructor("EMPTY");
    } else {
      setBankConstructor("LIST");
    }
  };

  const toogleArchive = (id: number, is_enabled: boolean) => {
    archiveBank({
      bank_id: id,
      is_enabled: !is_enabled,
    });
    if (!archiveError) {
      dispatch(
        BANK_ARCHIVE({
          bank_id: id,
          is_enabled: !is_enabled,
        }),
      );
    }
  };
  const addToArchive = () => {
    toogleArchive(selectedBank?.id, selectedBank?.is_enabled);
    changeSelectedBank(
      filteredBank?.filter((bank: IBank) => bank.id !== selectedBank.id)[0],
    );
  };

  return (
    <div className={classes.pageBank}>
      <div className={classes.pageBankHeader}>
        <div className={classes.pagerBankHeaderTitle}>
          Банки
        </div>

        <div className={classes.pageBankHeaderActions}>
          <Input 
            placeholder="Название банка"  
            size="large" 
            suffix={<SearchOutlined />}
            onChange={(event) => handleSearch(event.target.value)}
            className={classes.pageBankHeaderActionsInput}
            allowClear 
          />
            
          <Button className={classes.pageBankHeaderActionsSearchButton}>
            Найти
          </Button>

          <Button className={classes.pageBankHeaderActionsCancelButton}>
            Отменить
          </Button>
        </div>
      </div>
      
      <div className={classes.pageBankTableWrapper}>
        <Form form={form} component={false}>
          <Table
            components={{
              body: { cell: EditableCell },
            }}
            className={classes.pageBankTable}
            columns={mergedColumns}
            dataSource={dataBankTableSource}
            rowClassName="editable-row"
            pagination={false}
            size="small"
          />
        </Form>
      </div>

      <BankChronologyModal />
    </div>
  );
}
